import { render } from "./EditUserGroupUserMapping.vue?vue&type=template&id=6ad10f22"
import script from "./EditUserGroupUserMapping.vue?vue&type=script&lang=js"
export * from "./EditUserGroupUserMapping.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__